import ProductSection from "../../../../components/productSection/productSection";

export default function NewArrivalsSection(){
    return <ProductSection endPoint = "newArrivals-products" title = "NEW ARRIVALS" link = "/view-all-newArrivals"/>
}